import { Injectable } from "@angular/core";
import { Routes, RouterModule, ActivatedRoute, Router } from "@angular/router";

import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

import { Observable, Observer, Subject } from "rxjs";

import { AuthService } from "../services/auth.service";
// import { CookieService } from 'angular2-cookie/core';
import { CookieService } from "ngx-cookie";

@Injectable()
export class AuthTokenGuard implements CanActivate {
  username: any;
  password: any;
  hook_url: any;
  logged: any;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private _cookieService: CookieService,
    private router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    var subject = new Subject<boolean>();
    this.username = next.queryParams.username;
    this.password = next.queryParams.password;
    this.hook_url = next.queryParams.HOOK_URL;

    if (this._cookieService.get("NendiToken")) {
      return (this.logged = this.authService
        .isJwtValid(this._cookieService.get("NendiToken"), this.hook_url)
        .map((data) => data));
    }
    this.authService
      .getLogin(this.username, this.password, this.hook_url)
      .subscribe((logged) => {
        subject.next(logged);
      });

    return subject.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/auth-token.guard.ts